import { model as popupModel } from '$/info-popup'
import { MediaTypes } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import {
  continueWatchingModel,
  type SelectContinueWatchingParams,
} from '~/entities/continue-watching'
import { isContinueWatchingVodAndLocked } from './lib'

export const selectContinueWatching =
  createEvent<SelectContinueWatchingParams>()

export const $selectedContinueWatching = restore(selectContinueWatching, null)

sample({
  clock: selectContinueWatching,
  filter: ({ contentType, locked }) =>
    contentType !== MediaTypes.VOD || !locked,
  target: continueWatchingModel.redirectToPlayer,
})

sample({
  clock: selectContinueWatching,
  filter: ({ contentType, locked }) =>
    isContinueWatchingVodAndLocked({ contentType, locked }),
  fn: ({ contentId, contentName, locked }) => ({
    ...popupModel.emptyPinLockState,
    id: contentId || null,
    name: contentName || '',
    locked: locked || false,
  }),
  target: popupModel.openPinLockPopup,
})

sample({
  clock: popupModel.updateUnlockId,
  source: {
    selectedContinueWatchingParams: $selectedContinueWatching,
  },
  filter: ({ selectedContinueWatchingParams }, unlockedId) =>
    Boolean(selectedContinueWatchingParams) &&
    unlockedId === selectedContinueWatchingParams?.contentId,
  fn: ({ selectedContinueWatchingParams }) =>
    selectedContinueWatchingParams as SelectContinueWatchingParams,
  target: continueWatchingModel.redirectToPlayer,
})
